import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

export default function About() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" data-testid="about-section" className="bg-cream py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Left: sticky title + image */}
          <div className="lg:col-span-5">
            <Reveal>
              <p className="label-mono text-ocean mb-6">{t.about.label}</p>
              <h2 className="font-outfit font-semibold text-4xl md:text-6xl tracking-tight leading-[0.95] text-ink whitespace-pre-line">
                {t.about.title}
              </h2>
            </Reveal>
            <div ref={ref} className="mt-10 overflow-hidden aspect-[4/5] border border-black/10">
              <motion.img
                style={{ y }}
                src="https://images.pexels.com/photos/6737856/pexels-photo-6737856.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Local surf instructor at sunset"
                className="w-full h-[116%] object-cover"
              />
            </div>
          </div>

          {/* Right: numbered manifesto chapters */}
          <div className="lg:col-span-6 lg:col-start-7 space-y-14 lg:pt-10">
            {t.about.chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.08}>
                <div className="border-t border-black/10 pt-8">
                  <div className="flex items-start gap-6">
                    <span className="font-mono text-sand text-lg">{c.n}</span>
                    <div>
                      <h3 className="font-playfair italic text-2xl md:text-3xl text-ink mb-3">
                        {c.t}
                      </h3>
                      <p className="font-manrope text-ink/70 text-base md:text-lg leading-relaxed">
                        {c.d}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
